import script from "./ExcelPreviewTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ExcelPreviewTable.vue?vue&type=script&setup=true&lang=js"

import "./ExcelPreviewTable.vue?vue&type=style&index=0&id=57e47a8a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57e47a8a"]])

export default __exports__